<template>
  <div id="homepage">
                                                                                                                                                                                                                                                                 <div class="error-page" style="display: none">
      <div class="row justify-content-center error-page-row">
        <div class="row justify-content-center">
          <img src="lf_logo.svg" id="error-img" />
        </div>
        <label class="error-msg"
          >Link expired! Please contact your admin!</label
        >
      </div>
    </div>
    <h1 class="bg-white page-header">{{ page_title }}</h1>
    <div class="home">
      <input type="hidden" name="currentFrame" v-model="currentFrame" />
      <div class="home-section" :class="is_default ? 'home-section-360' : ''">
        <div
          id="livefurnish-360-wrapper-id"
          ref="livefurnish-360-wrapper-id"
          class="home-section-left livefurnish-360-wrapper fullscreen-wrapper border rounded"
          :class="is_default ? 'livefurnish-360-wrapper-fullscreen' : ''"
          @mousedown="setCounter"
          @mouseup="getCounter" 
          @dblclick="changeImage">

          <!-- <input type="text" id="zoom-test" style="width:500px"/> -->
          <!-- Loader -->
          <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :on-cancel="onCancel"
            :is-full-page="fullPage"
            loader="dots"
          />

          <div
            class="zoom-display rounded"
            :class="imageDisplay ? 'd-none' : ''"
          >
            <img class="img-fluid zoomed-img" src="" />
          </div>
          <div
            id="mySpriteSpin"
            class=""
            :class="imageDisplay ? '' : 'd-none'"
          ></div>
          <button type="button" class="zoom-btn" @click="toggle">
            <i class="bx bx-fullscreen"></i>
            <i class="bx bx-exit-fullscreen d-none"></i>
          </button>

          <div class="viewer-caption">
            <div v-if="!mobile_view">
              <span class="rounded" v-if="!zoomShow"
                >Drag to rotate and Double Click to zoom in</span
              >
              <span class="rounded" v-else
                >Hover to move and Double Click to zoom out</span
              >
            </div>

            <div v-if="mobile_view">
              <span class="rounded" v-if="!zoomShow"
                >Drag to rotate and Double Tap to zoom in</span
              >
              <span class="rounded" v-else
                >Hover to move and Double Tap to zoom out</span
              >
            </div>
          </div>

          <!-- <div class="" style="display: flex;"> -->
          <!-- <i class="fa fa-download download-frame" @click="download_current_frame()" aria-hidden="true"></i> -->
          <div class="btn-group">
            <i class="fa fa-download download-frame" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" ></i>
            <div class="dropdown-menu dropdown-menu-end">
              <!-- <div class="row dropdown-close-btn">
                <div class="col">
                  <i class="fa fa-times" aria-hidden="true" @click="close_dropdown"></i>
                </div>

              </div> -->
                <div class="dropdown-item" v-if="showMetaData">
                  <input type="checkbox" id="metadata-checkbox" @change="storeValue" v-model="previousMetadata">
                  <label class="" for="metadata-checkbox">MetaData</label>
                </div>

                <div class="dropdown-item" v-if="showWatermark">
                  <input type="checkbox" id="watermark-checkbox" @change="storeValue" v-model="previousWatermark">
                  <label class="" for="watermark-checkbox">WaterMark</label>
                </div>

              <div class="row download_images_row">
                <div class="col first">
                  <label @click="download_current_frame('png')">
                    Png<i class="fa fa-download" aria-hidden="true"></i>
                  </label>
                </div>
                <div class="col second">
                  <label @click="download_current_frame('jpeg')">
                    Jpeg<i class="fa fa-download" aria-hidden="true"></i>
                  </label>
                </div>
              </div>

            </div>
          </div>
          <!-- </div> -->
        </div>
        <div class="home-section-right">
          <!-- <Accordion
            :label="label"
            :default_textures="default_textures"
            @changedImages="newImages"
          /> -->
          <Accordion2
            :label="label"
            :default_textures="default_textures"
            :show_categories="show_categories"
            @changedImages="newImages"
            @updateSelectedTextureMergeId="updateSelectedTextureMergeId"
            @updateisLoadingValue="updateisLoadingValue"
            @updateFullScreenBackgroundColor="updateFullScreenBackgroundColor"
            @showUnauthorizedError="showUnauthorizedError"
            @updateSelectedTexturesData="updateSelectedTexturesData"
            @updateAllImages="updateAllImages"
            @updateMetaDataAndWaterMarkInfo="updateMetaDataAndWaterMarkInfo"
            @callChangeImageMethod="callChangeImageMethod"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../assets/scss/home.scss";

import { api as fullscreen } from "vue-fullscreen";
import axios from "axios";
// import Accordion from "../components/Accordion";
import Accordion2 from "../components/Accordion2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "Home",
  components: {
    Accordion2,
    Loading,
  },

  watch: {
    images() {
      this.$forceUpdate();
    },
  },
  data() {
    return {
      images: [], // 24 Low Images that are there in the response
      imagesZoom: [],
      label: "",
      fullscreen: false,
      teleport: true,
      page_title: "",
      zoomShow: false,
      is_default: false,
      default_textures: [],
      allData: [],
      imageDisplay: true,
      zoomImage: "",
      zoomLowImage: "",
      counter: 0,
      currentFrame: 0,
      updatedTexture: [],
      imgLimit: 8,
      // Om Changes
      selectedTextureMergeId: undefined,
      show_categories: false,
      FullScreenBackgroundColor: undefined,
      defaultfullscreenBG: "#fff",
      // Loader
      isLoading: false,
      fullPage: false,
      mobile_view: false,
      overlay: undefined,
      clientY: undefined,
      oldPercentLeft: 0.6,
      oldPercentTop: 0.5,
      host_name: undefined,

      mouseoffLeftStartPercent: undefined,
      mouseoffTopStartPercent: undefined,

      mouseoffLeftCurrentPercent: undefined,
      mouseoffTopCurrentPercent: undefined,

      mouseoffLeftOffsetPercent: 0.5,
      mouseoffTopOffsetPercent: 0.5,

      mouseoffLeftEndPercent: 0.5,
      mouseoffTopEndPercent: 0.5,
      token: undefined,

      // Query Params
      token: undefined,
      model_id: undefined,
      is_render_param: undefined,

      domainUrl: 'https://images.livefurnish.com',
      // Testing
      // domainUrl: "https://migration.livefurnish.com",
      isFirstTime: true,
      single_merge_data: {}, // For Merge API when zoomed
      waterMarkImage: '', // This is the watermark image url to merge it in th edownload image.
      MetaDataText: [], // This is for making a metadata image and later attaching to the Download image.
      allImages: [],  // 24 High Images that are there in the response
      showMetaData: false,
      showWatermark: false,
      META_DATA_BACKGROUND_COLOR: '#fff',

      previousMetadata: localStorage.getItem('metadata-checkbox') === 'true' ? true : false,
      previousWatermark: localStorage.getItem('watermark-checkbox') === 'true' ? true : false,
      download_format: 'png', // Default download format
      highResImageWidth: 1,
      highResImageHeight: 1,
      lowResImageWidth: 1,
      lowResImageHeight: 1,
      external_user_id: '',
      TIME_OUT_TIME: 1,  // In Minutes.
      Interval : undefined,
      downloadFrameNumber: 0,
      CurrentFrameNumberFinal: 0, // Another fields are giving inconsistency values
    };
  },
  created() {
    let that = this
    let host_name =
      window.location != window.parent.location
        ? document.referrer
        : document.location.href;
    this.host_name = new URL(host_name).host;
    // this.host_name = '360-test.livefurnish.com'

    // Getting the Params
    const params = window.location.search.split("?")[1].split("/"); // 0: Token, 1: model_id, 2: is_render
    this.token = params[0];
    this.model_id = params[1];
    let is_render = params[2];
    this.external_user_id = params[3];

    if (is_render === "1") {
      this.is_render_param = true;
    } else {
      this.is_render_param = false;
    }

    this.showLoader();
    this.StartTimer()
    axios
      .get(
        this.domainUrl +
          "/three-sixty/api/viewer/" +
          this.model_id +
          "/?token=" +
          this.token +
          "&is_render=" +
          this.is_render_param +
          "&host_name=" +
          this.host_name +
          "&ext=" + this.external_user_id
      )
      .then((response) => {
        this.StopTimer()
        let results = response.data.results;

        if (results.is_bg_color) {
          this.FullScreenBackgroundColor = results.bg_color;
        }

        this.is_default = results.is_default;
        this.show_categories = results.is_category;

        if (response.data.success) {
          this.allData = response.data.results;
          this.selectedTextureMergeId =
            this.allData.default_merge_data.unique_id;

          let results = response.data.results

          // Image Configs
          this.highResImageWidth = results.config_settings.render_reso_x
          this.highResImageHeight = results.config_settings.render_reso_y
          this.lowResImageWidth = results.config_settings.compressed_reso_x
          this.lowResImageHeight = results.config_settings.compressed_reso_y

          // Watermark link
          this.showWatermark = results.is_watermark
          if (this.showWatermark){
            this.waterMarkImage = results.watermark_file
          }

          if (results.is_default) {
            
            let default_data = results.default_data;

            this.allImages = JSON.parse(JSON.stringify(default_data))

            let temp_img = ''
            default_data.forEach((image) => {
              if (that.is_render_param){
                temp_img = image.threesixty_render_low
              }
              else{
                temp_img = image.threesixty_preview_low
              }
              this.images.push(temp_img);
              // this.imagesZoom.push(image.threesixty_render);
            });
          } else {
            let merge_data = results.default_merge_data;
            
            // Watermark link
            this.allImages = JSON.parse(JSON.stringify(merge_data.images))

            this.showMetaData = merge_data.is_metadata
            if (this.showMetaData){
              this.MetaDataText = merge_data.metadata
            }
            // this.showWatermark = false

            merge_data.images.forEach((image) => {
              this.images.push(image.image_low);
              // this.imagesZoom.push(image.image);
            });
            this.default_textures =
              response.data.results.default_merge_data.textures;
              console.log("Inside single_merge")
            this.single_merge_data = {
              basemodel: merge_data["basemodel"],
              textures: merge_data["textures"],
              is_render: this.is_render_param,
            };
          }
        } else {
          $.alert({
            title: "",
            content: response.data.message,
          });
        }
        response.data.results.label.forEach((element, index) => {
          element["start_image"] = 0;
          element["end_image"] = this.imgLimit - 1;
          element["amount"] = element.textures.length;
          element["page_id"] = 1;
          if (index == 0) {
            element["show"] = true;
          } else {
            element["show"] = false;
          }
          element.textures.forEach((texture) => {
            texture.active = true;
          });
        });
        this.label = response.data.results.label;
        this.page_title = response.data.results.name;

        this.zoomLowImage = this.images.filter(
          (image, index) => index == this.currentFrame
        )[0];

        this.create360(this.images, this.imagesZoom);

        this.hideLoader();
      })
      .catch((error) => {
        this.StopTimer()
        this.hideLoader();
        this.LinkExpiredError(error);
      });

    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    this.mobile_view =
      /iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(
        navigator.userAgent.toLowerCase()
      );

    // if (this.mobile_view){
    //   $('body').click(function(evt){
    //       if(evt.target.id == "menu_content")
    //           return;
    //       //For descendants of menu_content being clicked, remove this check if you do not want to put constraint on descendants.
    //       if($(evt.target).closest('#menu_content').length)
    //           return;

    //       //Do processing of click event here for every element except with id menu_content

    //   });

    // }
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize);
  },

  beforeCreated() {

  },

  afterMounted() {
    window.$(document).ready(function () {
      // document.querySelector("#accordion").style.height =
      //   document.querySelector(".home-section-left").style.clientHeight;
      setTimeout(function () {
        window.$(".spritespin-canvas").css({
          "max-height": "100%",
          "max-width": "100%",
          "aspect-ratio": "4/3",
        });
        window.$(".spritespin-stage").css({
          "max-height": "100%",
          "max-width": "100%",
          "aspect-ratio": "4/3",
        });
      }, 1500);
    });
  },
  methods: {
    StartTimer(){
      let time = this.TIME_OUT_TIME * 60000
      clearInterval(this.Interval)
      this.Interval = setInterval(function(){
        $.alert({
          title: '',
          content: 'Something went wrong. Please try again!'
        })
      }, time);
    },
    StopTimer(){
      clearInterval(this.Interval)
    },
    tempAlert(msg) {
      let duration = 2000;
      var el = document.createElement("div");
      el.setAttribute(
        "style",
        "position:absolute;top:40%;left:20%;background-color:white;"
      );
      el.innerHTML = msg;
      setTimeout(function () {
        el.parentNode.removeChild(el);
      }, duration);
      document.body.appendChild(el);
    },
    refreshPageLayout() {
      let screenWidht = window.$(window).width();
      let screenHeight = window.$(window).height();

      if (parseInt(screenWidht) < parseInt(screenHeight)) {
        window.$(".home-section").css({
          display: "flex",
          "flex-direction": "column",
          height: "100vh",
          "align-items": "center",
        });

        window.$("#homepage .home .home-section-right").css({
          height: "height: fit-content;",
        });

        $('.spritespin-stage').css({
          height: "unset !important",
        })
      } else {
        window.$(".home-section").css({
          display: "grid",
          height: "40vw",
          "flex-direction": "unset",
          "align-items": "unset",
        });

        window.$("#homepage .home .home-section-right").css({
          height: "fit-content",
        });
      }
    },
    detectRotation() {
      let that = this;
      window.addEventListener(
        "orientationchange",
        function () {
          // window.location.reload()
          that.refreshPageLayout();
        },
        false
      );

      window.addEventListener(
        "resize",
        function () {
          // window.location.reload()
          that.refreshPageLayout();
        },
        false
      );
    },
    showLoader() {
      // this.loading = true  // For starting loader
      this.isLoading = true;
    },
    hideLoader() {
      this.isLoading = false;
    },
    LinkExpiredError(error) {
      if (error.response) {
        if (error.response.status === 401) {
          window.$(".home").hide();
          window.$(".error-page").show();
        }
      }
    },
    disableIpadScroll() {
      let that = this;
      that.overlay = document.getElementById("livefurnish-360-wrapper-id");
      that.clientY = null; // remember Y position on touch start
      that.overlay.addEventListener(
        "touchstart",
        function (event) {
          // alert("Inside touchstart")
          if (event.targetTouches.length === 1) {
            // detect single touch
            this.clientY = event.targetTouches[0].clientY;
          }
        },
        false
      );

      that.overlay.addEventListener(
        "touchmove",
        function (event) {
          if (event.targetTouches.length === 1) {
            // detect single touch
            that.disableRubberBand(event);
          }
        },
        false
      );
    },
    disableRubberBand(event) {
      var clientY = event.targetTouches[0].clientY - this.clientY;
      if (this.overlay.scrollTop === 0 && clientY > 0) {
        // element is at the top of its scroll
        event.preventDefault();
      }

      if (this.isOverlayTotallyScrolled() && clientY < 0) {
        //element is at the top of its scroll
        event.preventDefault();
      }
    },
    isOverlayTotallyScrolled() {
      // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
      return (
        this.overlay.scrollHeight - this.overlay.scrollTop <=
        this.overlay.clientHeight
      );
    },

    showFullscreenBGColor() {
      let fullscreenBG = this.defaultfullscreenBG;
      // if (this.FullScreenBackgroundColor){
      //   fullscreenBG = this.FullScreenBackgroundColor
      // }
      window.$("#mySpriteSpin").css({
        "background-color": fullscreenBG,
      });

      window.$(".livefurnish-360-wrapper").css({
        "background-color": fullscreenBG,
      });
    },
    hideFullscreenBGColor() {
      window.$("#mySpriteSpin").css({
        "background-color": this.defaultfullscreenBG,
      });

      window.$(".livefurnish-360-wrapper").css({
        "background-color": this.defaultfullscreenBG,
      });
    },

    // Zoom Functionality
    ActivateZoom() {
      let that = this;
      let zoom_display = window.$(".livefurnish-360-wrapper");
      let container = zoom_display;
      const ZOOM_MULTIPLE_MOBILE = 1   // This times of the container the image should be zoomed.
      const ZOOM_MULTIPLE_LAPTOP = 1   // This times of the container the image should be zoomed.

      var touch_message = "";

      if (that.mobile_view) {
        zoom_display.bind("touchstart", function (e) {
          // added code
          //get the container width
          var conWidth = container.width(); //window.$(this).width();
          var conWidthX4 = container.width() * 4; //window.$(this).width();

          //and its height
          var conHeight = container.height(); //window.$(this).height();
          var conHeightX4 = container.height() * 4; //window.$(this).height();

          //get the nested img width
          var imgWidth = window.$(this).find("img").width();
          //and its height
          var imgHeight = window.$(this).find("img").height();
          //figure out how much of the image is not visible horizontally
          //var excessWidth = imgWidth - conWidth;
          var excessWidth = conWidthX4 - conWidth;
          //and how much is not visible vertically
          //var excessHeight = imgHeight - conHeight;
          var excessHeight = conHeightX4 - conHeight;
          //how far is this container from the left of the page
          var containerPositionLeft = zoom_display.offset().left;
          //and from the top
          var containerPositionTop = zoom_display.offset().top;
          // add code

          var touch = e.touches[0];
          //figure out how many pixels the mouse is from the left edge of the page
          var mouseoffLeftPage = touch.pageX;
          //and how many from the top edge of the page
          var mouseoffTopPage = touch.pageY;
          // //figure out how many pixels the mouse is from the left edge of the page
          var mouseoffLeftPx = mouseoffLeftPage - containerPositionLeft;
          // //and how many from the top edge of the page
          var mouseoffTopPx = mouseoffTopPage - containerPositionTop;
          // //figure out the distance the mouse is from the left edge as a percentage (kind of - all the way to the right equals 1 not 100)

          that.mouseoffLeftStartPercent = mouseoffLeftPx / conWidth;
          that.mouseoffTopStartPercent = mouseoffTopPx / conHeight;
          touch_message =
            "touch_start" +
            " mouseoffLeftPx:" +
            mouseoffLeftPx +
            " mouseoffTopPx:" +
            mouseoffTopPx;
          window.$("#zoom-test").val(touch_message);
        });

        zoom_display.bind("touchmove", function (e) {
          // added code
          //get the container width
          var conWidth = container.width(); //window.$(this).width();
          var conWidthX4 = container.width() * 4; //window.$(this).width();

          //and its height
          var conHeight = container.height(); //window.$(this).height();
          var conHeightX4 = container.height() * 4; //window.$(this).height();

          //get the nested img width
          var imgWidth = window.$(".zoomed-img").prop("naturalWidth");
          //and its height
          var imgHeight = window.$(".zoomed-img").prop("naturalHeight");


          if (that.highResImageWidth * ZOOM_MULTIPLE_MOBILE > conWidth){
            imgWidth = that.highResImageWidth * ZOOM_MULTIPLE_MOBILE
            imgHeight = that.highResImageHeight * ZOOM_MULTIPLE_MOBILE
          }
          else{
            // while(that.highResImageWidth * ZOOM_MULTIPLE_MOBILE < conWidth){
             try{
              ZOOM_MULTIPLE_MOBILE += 0.01
             }
            catch(e){
              // Ignoring error in console.
            }
              imgWidth = that.highResImageWidth * ZOOM_MULTIPLE_MOBILE
              imgHeight = that.highResImageHeight * ZOOM_MULTIPLE_MOBILE
            // }
           
          }

          // if (conWidth * ZOOM_MULTIPLE > imgWidth){
          //   imgWidth = conWidth * ZOOM_MULTIPLE
          //   imgHeight = conWidth * ZOOM_MULTIPLE
          // }

          window.$('.zoomed-img')
          .css({
            height: imgHeight,
            width: imgWidth
          });
          //figure out how much of the image is not visible horizontally
          //var excessWidth = imgWidth - conWidth;
          // var excessWidth = conWidthX4 - conWidth;
          // //and how much is not visible vertically
          // //var excessHeight = imgHeight - conHeight;
          // var excessHeight = conHeightX4 - conHeight;

          // New
          var excessWidth = imgWidth - conWidth;
          //and how much is not visible vertically
          //var excessHeight = imgHeight - conHeight;
          var excessHeight = imgHeight - conHeight;

          //how far is this container from the left of the page
          var containerPositionLeft = zoom_display.offset().left;
          //and from the top
          var containerPositionTop = zoom_display.offset().top;
          // add code

          var touch = e.touches[0];
          //figure out how many pixels the mouse is from the left edge of the page
          var mouseoffLeftPage = touch.pageX;
          //and how many from the top edge of the page
          var mouseoffTopPage = touch.pageY;
          // //figure out how many pixels the mouse is from the left edge of the page
          var mouseoffLeftPx = mouseoffLeftPage - containerPositionLeft;
          // //and how many from the top edge of the page
          var mouseoffTopPx = mouseoffTopPage - containerPositionTop;
          // //figure out the distance the mouse is from the left edge as a percentage (kind of - all the way to the right equals 1 not 100)

          that.mouseoffLeftCurrentPercent = mouseoffLeftPx / conWidth;
          that.mouseoffTopCurrentPercent = mouseoffTopPx / conHeight;

          var mouseoffLeftDifference =
            that.mouseoffLeftCurrentPercent - that.mouseoffLeftStartPercent;
          var mouseoffTopDifference =
            that.mouseoffTopCurrentPercent - that.mouseoffTopStartPercent;

          that.mouseoffLeftOffsetPercent =
            that.mouseoffLeftEndPercent - mouseoffLeftDifference;
          that.mouseoffTopOffsetPercent =
            that.mouseoffTopEndPercent - mouseoffTopDifference;
          const min = 0;
          const max = 1;

          // Clamp number between two values with the following line:
          const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

          that.mouseoffLeftOffsetPercent = clamp(
            that.mouseoffLeftOffsetPercent,
            min,
            max
          );
          that.mouseoffTopOffsetPercent = clamp(
            that.mouseoffTopOffsetPercent,
            min,
            max
          );

          //times the 'percentage' value by the amount of image hidden - so if your conatiner is 200px wide, your image 300px wide nd your mouse is half way across this value would be 0.5*100 which would give you 50 - which is exactly half the amount of image that is missing.
          //note this gets set as a minus value as we will be using a minus number to shift the image around.
          var setnewWidth =
            -(that.mouseoffLeftOffsetPercent * excessWidth) + excessWidth / 2;
          //do the same for the height
          var setnewHeight =
            -(that.mouseoffTopOffsetPercent * excessHeight) + excessHeight / 2;
          //add the values as css (using transform(translate) as it's more performant and does subpixel rendering so looks smoother [or does it? it does in animations but seems as my js is not technically animating it it might not make a difference in that respect] - could set the top,left version as fallback for unsupporting browsers but ie9 supports transforms anyway so i dont care.)
          // window.$(this).find("img").css({"transform" : "translate("+ setnewWidth+"px ,"+setnewHeight+"px, scale(3,3))" });

          // window.$('.zoomed-img').css({transform:
          //   "translate(" +
          //   setnewWidth +
          //   "px, " +
          //   setnewHeight +
          //   "px)",
          //   "object-fit": "cover",
          //     height: conHeightX4,
          //     width: conWidthX4
          //   });

          // New
          window.$(".zoomed-img").css({
            transform:
              "translate(" + setnewWidth + "px, " + setnewHeight + "px)",
            "object-fit": "cover",
            // height: conHeightX4,
            // width: conWidthX4
          });

          touch_message = "touchmove";
          +" CurrentX:" +
            that.mouseoffLeftCurrentPercent +
            " currentY:" +
            that.mouseoffTopCurrentPercent;
        });

        zoom_display.bind("touchend", function (e) {
          //figure out how many pixels the mouse is from the left edge of the page
          //var mouseoffLeftPage = e.pageX;
          //and how many from the top edge of the page
          //var mouseoffTopPage = e.pageY;
          // //figure out how many pixels the mouse is from the left edge of the page
          //var mouseoffLeftPx = mouseoffLeftPage - containerPositionLeft;
          // //and how many from the top edge of the page
          //var mouseoffTopPx = mouseoffTopPage - containerPositionTop;
          // //figure out the distance the mouse is from the left edge as a percentage (kind of - all the way to the right equals 1 not 100)
          console.log("Inside zoomed value in mob", that.zoomShow)
          that.mouseoffLeftEndPercent = that.mouseoffLeftOffsetPercent; //mouseoffLeftPx/conWidth;
          that.mouseoffTopEndPercent = that.mouseoffTopOffsetPercent; //mouseoffTopPx/conHeight;
        });
      } else {
        //when moving mouse over container
        zoom_display.bind("mousemove ", function (e) {

          var conWidth = container.width(); //window.$(this).width();
          var conWidthX4 = container.width() * 4; //window.$(this).width();

          //and its height
          var conHeight = container.height(); //window.$(this).height();
          var conHeightX4 = container.height() * 4; //window.$(this).height();

          //get the nested img width
          var imgWidth = window.$(".zoomed-img").prop("naturalWidth");
          //and its height
          var imgHeight = window.$(".zoomed-img").prop("naturalHeight");

          if (that.highResImageWidth * ZOOM_MULTIPLE_LAPTOP > conWidth){
            imgWidth = that.highResImageWidth * ZOOM_MULTIPLE_LAPTOP
            imgHeight = that.highResImageHeight * ZOOM_MULTIPLE_LAPTOP
          }
          else{
            // while(that.highResImageWidth * ZOOM_MULTIPLE_LAPTOP < conWidth){
              try{
                ZOOM_MULTIPLE_LAPTOP += 0.01
              }
              catch(e){

              }
            // }
            imgWidth = that.highResImageWidth * ZOOM_MULTIPLE_LAPTOP
            imgHeight = that.highResImageHeight * ZOOM_MULTIPLE_LAPTOP
          }

          // if (conWidth * ZOOM_MULTIPLE > imgWidth){
          //   imgWidth = conWidth * ZOOM_MULTIPLE
          //   imgHeight = conWidth * ZOOM_MULTIPLE
          //   console.log("Inside conWidth > imgWidth", conWidth > imgWidth)
          // }

          window.$('.zoomed-img')
            .css({
              height: imgHeight,
              width: imgWidth
            });
          // New
          var excessWidth = imgWidth - conWidth;
          //and how much is not visible vertically
          //var excessHeight = imgHeight - conHeight;
          var excessHeight = imgHeight - conHeight;

 
          //how far is this container from the left of the page
          var containerPositionLeft = zoom_display.offset().left;
          //and from the top
          var containerPositionTop = zoom_display.offset().top;

          //let scale = 2
          //figure out how many pixels the mouse is from the left edge of the page
          var mouseoffLeftPage = e.pageX;
          //and how many from the top edge of the page
          var mouseoffTopPage = e.pageY;
          //figure out how many pixels the mouse is from the left edge of the page
          var mouseoffLeftPx = mouseoffLeftPage - containerPositionLeft;
          //and how many from the top edge of the page
          var mouseoffTopPx = mouseoffTopPage - containerPositionTop;
          //figure out the distance the mouse is from the left edge as a percentage (kind of - all the way to the right equals 1 not 100)
          var mouseoffLeftPercent;
          var mouseoffTopPercent;

          mouseoffLeftPercent = mouseoffLeftPx / conWidth;
          mouseoffTopPercent = mouseoffTopPx / conHeight;

          //times the 'percentage' value by the amount of image hidden - so if your conatiner is 200px wide, your image 300px wide nd your mouse is half way across this value would be 0.5*100 which would give you 50 - which is exactly half the amount of image that is missing.
          //note this gets set as a minus value as we will be using a minus number to shift the image around.
          var setnewWidth =
            -(mouseoffLeftPercent * excessWidth) + excessWidth / 2;
          //do the same for the height
          var setnewHeight =
            -(mouseoffTopPercent * excessHeight) + excessHeight / 2;
          //add the values as css (using transform(translate) as it's more performant and does subpixel rendering so looks smoother [or does it? it does in animations but seems as my js is not technically animating it it might not make a difference in that respect] - could set the top,left version as fallback for unsupporting browsers but ie9 supports transforms anyway so i dont care.)
          // window.$(this).find("img").css({"transform" : "translate("+ setnewWidth+"px ,"+setnewHeight+"px, scale(3,3))" });

          window.$('.zoomed-img')
            .css({
              transform:
                "translate(" + setnewWidth + "px, " + setnewHeight + "px)",
              "object-fit": "cover",
            });

        // if (conWidth > imgWidth){
        //   // window.$('.zoomed-img').height(imgHeight)
        //   // window.$('.zoomed-img').width(imgWidth)
        //   window.$('.zoomed-img')
        //     .css({
        //       height: imgHeight,
        //       width: imgWidth
        //     });
        // }

                          
        });
        // })
      }
    },
    handleResize() {
      // if (window.innerWidth < 700) {
      //   this.imgLimit = 6;
      // } else {
      //   this.imgLimit = 8;
      // }
    },
    setCounter() {
      this.counter = new Date();
    },
    getCounter() {
      let current = new Date();
      let delta = (current - this.counter) / 1000.0;

      if (delta < 0.01) {
        // this.changeImage();
      }
    },
    async toggle() {
      let that = this;
      await fullscreen.toggle(this.$el.querySelector(".fullscreen-wrapper"), {
        teleport: this.teleport,
        callback: (isFullscreen) => {
          this.fullscreen = isFullscreen;
          this.imageDisplay = true;
          this.zoomShow = false;

          if (isFullscreen) {
            window.$(".home-section-right").addClass("d-none");
            window.$(".zoom-btn .bx-fullscreen").addClass("d-none");
            // Background color when image has background color.

            window
              .$(".zoom-btn .bx-exit-fullscreen")
              .removeClass("d-none")
              .css({
                transform: "scale(2.3)",
              });
            window.$(".page-header").addClass("d-none");

            window.$(".zoom-btn").css({
              position: "fixed",
              top: 15,
              right: 10,
              "background-color": "transparent",
              border: "none",
              cursor: "pointer",
            });

            window
              .$(".viewer-caption")
              .css({ position: "fixed", bottom: "10px" });
            window.$(".viewer-caption span").css({
              "background-color": "rgba(225, 225, 225, 0.5)",
              padding: "5px",
            });

            window.$(".livefurnish-360-wrapper").css({
              display: "flex",
              "align-items": "center",
              "justify-content": "center",
              width: "100vw",
            });
            window.$("#mySpriteSpin").removeClass("border").css({
              "max-height": "100vh",
              height: "100%",
            });
            window.$(".viewer-caption").css({
              display: "fixed",
            });

            this.showFullscreenBGColor();
          } else {
            this.hideFullscreenBGColor();
            window.$(".home-section-right").removeClass("d-none");
            window.$(".zoom-btn .bx-fullscreen").removeClass("d-none");
            window.$(".zoom-btn .bx-exit-fullscreen").addClass("d-none");
            window.$(".zoom-btn").css({
              position: "absolute",
              top: 0,
              right: 0,
            });
            window.$(".page-header").removeClass("d-none");
            window.$(".viewer-caption").css({ position: "absolute" });
            window.$(".livefurnish-360-wrapper").css({
              display: "block",
            });
            window.$("#mySpriteSpin").css({
              // "max-height": "768px",
              height: "auto",
            });
            window.$(".livefurnish-360-wrapper-fullscreen").css({
              display: "flex",
              "align-items": "center",
              // height: "85vh",
            });
          }
        },
      });
      this.fullscreen = fullscreen.isFullscreen;
    },
    create360(images, imagesZoom) {
      let that = this;
      imagesZoom; // Just to avoid not used error
      console.log("Images in spritespin", images)
      window.$("#mySpriteSpin").spritespin({
        // path to the source images.
        source: Object.values(images),
        sourceZoom: [],
        sense: 1,
        animate: false,
        plugins: ["360", "drag", "progress"],
        sizeMode: "fill",
        onInit: function (e, data) {
          that.showLoader();
        },
        onDraw: function (e, data) {
          if (!that.isFirstTime) {
            that.hideLoader();
          }
        },
        onFrame: function (e, data) {
          that.CurrentFrameNumberFinal = data.frame
          window.$("input[name=currentFrame]").val(data.frame);
        },
        onLoad: function (e, data) {
          that.hideLoader();
        },
        onComplete: function (e, data) {
          that.isFirstTime = false;
          that.hideLoader();
        },
      });
      window.$(".spritespin-progress").css({
        top: "50%",
      });
    },
    showHighResImageAfterLoading(link) {
      var img = new Image();
      $(img).on("load", function () {
        $(".zoomed-img").attr("src", link);
      });
      img.src = link;
    },
    changeImage(event) {
      if (event){
        if($(event.target).closest('.btn-group').length !== 0 )
        {
            return false
        }
      }

      // $('.zoomed-img').css({'transform': 'unset'})
      // this.mouseoffTopEndPercent = 0.5;
      // this.mouseoffLeftEndPercent = 0.5

      let that = this
      this.currentFrame = window.$("input[name=currentFrame]").val();
      this.imageDisplay = !this.imageDisplay;
      this.zoomShow = !this.zoomShow;

      console.log("this.allData", this.allData)
      if (!this.is_default) {
        let selected_img = this.allData.default_merge_data.images.filter(
          (image, index) => {
            return index == this.currentFrame;
          }
        );
        this.zoomImage = selected_img[0].image;
        this.zoomLowImage = selected_img[0].image_low;
      } else {
        let selected_img = this.allData.default_data.filter(
          (image, index) => {
            return index == this.currentFrame;
          }
        );
        console.log("selected image", selected_img)
        if (that.is_render_param){
          this.zoomImage = selected_img[0].threesixty_render;
        }
        else{
          this.zoomImage = selected_img[0].threesixty_preview;
        }

        
        if (that.is_render_param){
          this.zoomLowImage = selected_img[0].threesixty_render_low;
        }
        else{
          this.zoomLowImage = selected_img[0].threesixty_preview_low;
        }
        
      }

      if (this.updatedTexture.length !== 0) {
        let selected_img = this.updatedTexture.images.filter((image, index) => {
          return index == this.currentFrame;
        });
        this.zoomImage = selected_img[0].image;
        this.zoomLowImage = selected_img[0].image_low;
      }

      let zoomed_img = window.$(".zoomed-img");

      zoomed_img.attr("src", this.zoomLowImage); // Making this empty because background would be over-ridden by src

      if (this.zoomImage) {
        this.showHighResImageAfterLoading(this.zoomImage);
      } else {
          that.MergeSingleImage(this.showHighResImageAfterLoading);
      }

      // high_res_image.attr('src', this.zoomImage)
      // let background_url_string = "background: url(" + this.zoomLowImage + "; url(" + this.zoomImage + ";)"

      // high_res_image.on('load', function(){
      //   high_res_image.show()
      //   low_res_image.hide()
      // })
    },
    MergeSingleImage(callback) {
      console.log("Inside MergeSingleImage")
      let single_merge_url =
        this.domainUrl +
        "/three-sixty/api/single_merge/" +
        "?token=" +
        this.token +
        "&host_name=" +
        this.host_name +
        "&ext=" + this.external_user_id;

      let current_frame_id = this.CurrentFrameNumberFinal

      this.single_merge_data["seq_no"] = current_frame_id;

      return axios
        .post(single_merge_url, this.single_merge_data)
        .then((response) => {
          console.log("Inside MergeSingleImage response")
          this.hideLoader();
          let data = response.data;
          if (data.success === true) {
            this.allImages[current_frame_id] = data.results
            let high_res_image = data.results.image;
            if (callback){
              callback(high_res_image)
            }
            // this.showHighResImageAfterLoading(high_res_image);
          }
        })
        .catch((error) => {
          this.hideLoader();
          this.LinkExpiredError(error);
        });
    },
    newImages(value) {
      this.updatedTexture = value;
      this.images = this.imagesZoom = [];
      value.images.forEach((image) => {
        this.images.push(image.image_low);
        // this.imagesZoom.push(image.image_low);
      });
      // this.$forceUpdate();
      this.create360(this.images, []);
    },
    // --Omkar
    updateSelectedTextureMergeId(value) {
      this.selectedTextureMergeId = value;
    },
    updateMetaDataAndWaterMarkInfo(data){
      this.showMetaData = data.is_metadata
      this.showWatermark = data.is_watermark
      this.MetaDataText = data.metadata
    },
    updateisLoadingValue(value) {
      this.isLoading = value;
    },
    updateFullScreenBackgroundColor(value) {
      // Updating fullscreen background color
      this.FullScreenBackgroundColor = value;
    },
    showUnauthorizedError(error) {
      this.LinkExpiredError(error);
    },
    updateSelectedTexturesData(data) {
      // Updating the selected textures data
      this.single_merge_data = data;
    },
    callChangeImageMethod(){
      this.changeImage()
    },
    updateAllImages(data){
      this.allImages = data
    },
    download_current_frame(image_format) {
      this.showLoader()
      this.download_format = image_format
      console.log("Inside download_current_frame", this.allImages) 
      let that = this
      let current_frame_id = that.CurrentFrameNumberFinal
      let main_image;
      this.downloadFrameNumber = current_frame_id

      if (this.is_default){
        let temp_img;
        if (that.is_render_param){
          temp_img = this.allImages[current_frame_id].threesixty_render
        }
        else{
          temp_img = this.allImages[current_frame_id].threesixty_preview
        }
        main_image = temp_img
      }
      else{
        main_image = this.allImages[current_frame_id].image
      }

      // for testing
      if (!main_image){
        // main_image = this.allImages[current_frame_id].image_low
        this.MergeSingleImage(this.loadImageForDownload)
      }
      else{
        this.loadImageForDownload()
      }

    },
    loadImageForDownload(){
      let that = this
      let enable_metadata = window.$('#metadata-checkbox').prop('checked')
      let enable_watermark = window.$('#watermark-checkbox').prop('checked')
      let current_frame_id = this.downloadFrameNumber
      let main_image;

      if (this.is_default){
                let temp_img;
        if (that.is_render_param){
          temp_img = this.allImages[current_frame_id].threesixty_render
        }
        else{
          temp_img = this.allImages[current_frame_id].threesixty_preview
        }
        main_image = temp_img
      }
      else{
        main_image = this.allImages[current_frame_id].image
      }

      console.log("Inside loadImageForDownload")
      var img = new Image();
      img.crossOrigin="anonymous"
      window.$(img).on("load", function () {
          let main_image_width =  $(this).prop("naturalWidth")
          let main_image_height =  $(this).prop("naturalHeight")

          var canvas = document.createElement('canvas')
          var context = canvas.getContext('2d') //Hidden canvas

          canvas.width = main_image_width
          // Making metaData Image on Canvas
          if (enable_metadata){
            that.MakeMetaDataImage(context, main_image_width, main_image_height)
          }
          else{
            canvas.height = main_image_height
          }

          // Drawing the Main Image
          context.drawImage(img, 0, 0, main_image_width, main_image_height);
          
          if (enable_watermark){
            that.MergeWaterMarkImage(context, main_image_width, main_image_height)
          }
          else{
            // Directly download the image
            that.downloadMergedImage(context)
          }

          
      });
      img.src = main_image
    },
    MakeMetaDataImage(context, main_image_width, main_image_height){
        let that = this
        let TEXT_START_POSITION = 15
        let DESCRIPTION_SPACE = 50
        let LINE_SPACE = 30
        let data = this.MetaDataText
        let meta_data_start_y = main_image_height + TEXT_START_POSITION

        // Write into Canvas
        var TITLE_START_POSITION = 30;
        var y = meta_data_start_y;
        // MetaData CSS
        let metaDataFontSize = parseInt((1.3 / 100) * main_image_width)
        let marginLeft = parseInt(0.0156 * main_image_width)


        let allines = data.length
        let offsetBottom = parseInt(metaDataFontSize * 0.5)
        let offsetTop = parseInt(metaDataFontSize * 0.5)

        // Counting total Lines
        // let total_lines = 1
        // window.$.each(data, function(index, metaData){
        //     let title = metaData['title']
        //     let description = that.InsertNewLines(context, title, metaData['data'], DESCRIPTION_SPACE, main_image_width)
        //     description = description.split('\n')
        //     $.each(description, function(index, value){
        //       total_lines += 1
        //     })
        // })

        let lineSpacingPercentage = parseInt(0.7 * metaDataFontSize)
        let lineSpacing = parseInt(lineSpacingPercentage) + LINE_SPACE
        var lineheight = lineSpacing;

        let total_lines = 1
        window.$.each(data, function(index, metaData){
            let title = metaData['title']
            context.font = `bold ${metaDataFontSize}px Arial`;
            let description = that.InsertNewLines(context, title, metaData['data'], DESCRIPTION_SPACE, main_image_width)
            description = description.split('\n')

            $.each(description, function(index, value){
              context.font = `${metaDataFontSize}px Arial`;
              total_lines += 1
            })
        })


        let metaDataImageHeight = lineSpacing * (total_lines) + TEXT_START_POSITION
        context.canvas.height = main_image_height + metaDataImageHeight
        
        context.fillStyle = this.META_DATA_BACKGROUND_COLOR
        context.fillRect(0, 0, context.canvas.width, context.canvas.height);

        let line_no = 1
        window.$.each(data, function(index, metaData){
            let title = metaData['title']

            context.fillStyle = '#000000'
            context.font = `bold ${metaDataFontSize}px Arial`;
            context.fillText(title, TITLE_START_POSITION, y + (line_no * lineheight));

            let description = that.InsertNewLines(context, title, metaData['data'], DESCRIPTION_SPACE, main_image_width)
            description = description.split('\n')

            $.each(description, function(index, value){
              let data_size
              if (index === 0){
                data_size = parseInt(context.measureText(title).width + DESCRIPTION_SPACE)
              }
              else{
                data_size = TITLE_START_POSITION
              }
              context.fillStyle = '#000000'
              context.font = `${metaDataFontSize}px Arial`;
              context.fillText(value, data_size, y + (line_no * lineheight));
              line_no += 1
            })
        })

    },
    InsertNewLines(context, title, description, DESCRIPTION_SPACE, main_image_width){
      let str = description
      let count_length = 0
      let EXTRA_SPACE = 10
      let tempString = ''
      let total_line_width;
      while (str.length > 0){
        tempString += str[0]
        str = str.slice(1)
        total_line_width = context.measureText(title).width + DESCRIPTION_SPACE + context.measureText(tempString).width + EXTRA_SPACE
        if (total_line_width > main_image_width){
          // jkkjh
          description = this.InsertString(description, tempString.length - 1, '\n')
          tempString = ''
        }
      }
      return description
    },
    InsertString(str, index, value) {
      return str.substr(0, index) + value + str.substr(index);
    },
    MergeWaterMarkImage(context, imgWidth, imgHeight){
      let that = this
      var img = new Image();
      img.crossOrigin="anonymous"
      window.$(img).on("load", function () {
        // Calculating water mark position and size
        let waterMarkWidth = window.$(this).prop('naturalWidth')
        let waterMarkHeight = window.$(this).prop('naturalHeight')

        let multipleValue = parseInt((8/100) * imgWidth)
        let sizeDivider = waterMarkWidth

        if (imgWidth < imgHeight || imgWidth === imgHeight ){
            multipleValue = parseInt((8/100) * imgWidth)
            sizeDivider = waterMarkHeight
        }

        let percentage = multipleValue / sizeDivider

        let LogoWidth = parseInt(waterMarkWidth * percentage)
        let LogoHeight = parseInt(waterMarkHeight * percentage)

        let watermarkPositionX = imgWidth - LogoWidth
        let watermarkPositionY = imgHeight - LogoHeight

        context.drawImage(img, watermarkPositionX, watermarkPositionY, LogoWidth, LogoHeight)
        that.downloadMergedImage(context)
      })
      img.src = this.waterMarkImage
    },
    downloadMergedImage(context){
      let image_format = this.download_format
      let current_frame_id = this.downloadFrameNumber
      let imageElem = document.createElement('img'); //Image element
      imageElem.src = context.canvas.toDataURL(`image/${image_format}`);
      let download_image_name = `${this.page_title}_${current_frame_id}.${image_format}`
      let a_tag = window.$('<a></a>')
      a_tag.attr('target', '_blank')
      a_tag.attr('href', imageElem.src)
      a_tag.attr('download', download_image_name)
      a_tag[0].click()
      this.hideLoader()
    },
    storeValue(event){
      let current_id = $(event.target).attr('id')
      let checked = $(event.target).prop('checked')
      localStorage.setItem(current_id, checked);
    },
    close_dropdown(){
      window.$('.download-frame').dropdown('toggle')
    },
    detectBrowser() { 
    if((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1 ) {
        //
    } else if(navigator.userAgent.indexOf("Chrome") != -1 ) {
       console.log("Inside chrome")
       var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
       if (iOS){
         $('.download_images_row .first').remove()
       }
       //
    } else if(navigator.userAgent.indexOf("Safari") != -1) {
        //
    } else if(navigator.userAgent.indexOf("Firefox") != -1 ){
        //
    } else if((navigator.userAgent.indexOf("MSIE") != -1 ) || (!!document.documentMode == true )) {
        //
    } else {
        //
    }
} 
  },
  mounted() {
    let that = this;
    // Calling here as the html element can be grabbed from here.
    this.disableIpadScroll();
    this.ActivateZoom();
    this.detectRotation();
    this.detectBrowser()

    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (iOS){
      let chrome_in_ios = navigator.userAgent.match('CriOS')
      if (chrome_in_ios){
        $('.download_images_row .first').remove()
      }
    }

    window.$(document).ready(function () {
      that.refreshPageLayout();
    });
  },
};
</script>
